// extracted by mini-css-extract-plugin
export default {"root":"root--Nenoxi62K0YpcMv","oranum":"oranum--y2H6nPWOooaTseT","container":"container--Nq928A10PVxnCRq","menu":"menu--mTMp6NXo_tUi___","backdrop":"backdrop--llPaP3bY1nmyHHG"};